// 智能锁——主流程
const MainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `lock/index${i + 1}`,
  name: `lockIndex${i + 1}`,
  component: () => import(`@/views/smartLife/lock/index${i + 1}.vue`)
}))

export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 智能锁——主流程，开始
    ...MainRoutes

  ]
}
